import Notification from 'flarum/components/Notification';

export default class BestAnswerInDiscussionNotification extends Notification {
    icon() {
        return 'fas fa-check';
    }

    href() {
        const notification = this.props.notification;
        const discussion = notification.subject();

        return app.route.discussion(discussion);
    }

    content() {
        const user = this.props.notification.fromUser();
        return app.translator.trans('fof-best-answer.forum.notification.best_answer_in_discussion', {
            user: user,
        });
    }
}
